<template>
  <div>
    <base-title
      title="API de Conversões do Facebook"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-register">
      <div class="header">
        <div class="d-flex justify-between align-center w-100">
          <p class="title">Informações</p>
          <div class="toggle" @click="toggle()">
            <input type="checkbox" id="toggle-checkbox" v-model="toggleOn" />

            <div
              class="toggle-control"
              :class="toggleOn ? 'toggleOn' : 'toggleOff'"
            >
              <span class="control">
                <span>{{ toggleOn ? 'Ativado' : 'Desativado' }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="form">
        <base-input
          :valid="registerValid.id"
          placeholder="ID do pixel"
          class="w-100"
          v-model="id"
          @blur="validateId"
          @focus="registerValid.id = true"
        />

        <base-input
          placeholder="Token de acesso"
          class="w-100"
          v-model="token"
          :valid="registerValid.token"
        />
        <div @click="save()" class="d-flex justify-end mt_20">
          <base-button text="Salvar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseInput from '@/components/Input.vue';
import StoreAPI from '../../../api/store';

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseInput,
  },
  data() {
    return {
      toggleOn: true,
      id: '',
      token: '',
      registerValid: {
        id: true,
        token: true,
      },
    };
  },

  async created() {
    const response = await StoreAPI.storeGetConfiguration();

    const configuration = response.getData([]);

    if (configuration.pixel) {
      this.toggleOn = configuration.pixel.active;
      this.id = configuration.pixel.id;
      this.token = configuration.pixel.token;
      this.backRoute = 'integracoes';
    }
    this.verifyDomain();
  },
  methods: {
    async verifyDomain() {
      const checkDomains = await StoreAPI.getDomains();
      if (!Array.isArray(checkDomains.getData())) {
        this.$router.push({ name: 'facebook-pixel' });
      }
    },
    toggle() {
      this.toggleOn = !this.toggleOn;
    },
    validateId() {
      if (this.id.length <= 16) {
        for (const num of this.id) {
          if (parseInt(num)) {
            return;
          }
        }
      }
      this.registerValid.id = false;
    },
    async save() {
      if (this.id.length === 0 || !this.id) {
        this.registerValid.id = false;
        return;
      }

      // if (this.token.length === 0 || !this.token) {
      //   this.registerValid.token = false;
      //   return;
      // }

      const response = await StoreAPI.storeConfiguration({
        pixel: {
          id: this.id,
          token: this.token,
          active: this.toggleOn,
        },
      });

      if (response.getErrors([]).length > 0) {
        this.registerValid.token = false;
        this.registerValid.id = false;
        alert('Ocorreu um error');
      }

      this.backRoute = 'integracoes';
    },
  },
};
</script>
